import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './number-of-bedrooms.reducer';

export const NumberOfBedroomsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const numberOfBedroomsEntity = useAppSelector(state => state.numberOfBedrooms.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="numberOfBedroomsDetailsHeading">
          <Translate contentKey="apiLocationApp.numberOfBedrooms.detail.title">NumberOfBedrooms</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.date">Date</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllHouseholds">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.totalAllHouseholds">Total All Households</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.totalAllHouseholds}</dd>
          <dt>
            <span id="noBedroom">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.noBedroom">No Bedroom</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.noBedroom}</dd>
          <dt>
            <span id="oneBedroom">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.oneBedroom">One Bedroom</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.oneBedroom}</dd>
          <dt>
            <span id="twoBedrooms">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.twoBedrooms">Two Bedrooms</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.twoBedrooms}</dd>
          <dt>
            <span id="threeBedrooms">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.threeBedrooms">Three Bedrooms</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.threeBedrooms}</dd>
          <dt>
            <span id="fourBedrooms">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.fourBedrooms">Four Bedrooms</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.fourBedrooms}</dd>
          <dt>
            <span id="fiveOrMoreBedrooms">
              <Translate contentKey="apiLocationApp.numberOfBedrooms.fiveOrMoreBedrooms">Five Or More Bedrooms</Translate>
            </span>
          </dt>
          <dd>{numberOfBedroomsEntity.fiveOrMoreBedrooms}</dd>
        </dl>
        <Button tag={Link} to="/number-of-bedrooms" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/number-of-bedrooms/${numberOfBedroomsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NumberOfBedroomsDetail;
